import React from 'react'
import { useSession } from '../index'
//  Default Component to show when user is not authorized to user application.
const NotAuthorizedPage = () => {
  const { session } = useSession()

  const userIdentifier =
    session.idToken.payload.name || session.idToken.payload.email

  return (
    <div>
      <h4> User {userIdentifier} is not authorized to access application. </h4>
    </div>
  )
}

export default NotAuthorizedPage
